import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8b2de1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-com" }
const _hoisted_2 = { class: "department-wrap" }
const _hoisted_3 = { class: "option-wrap" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "info-wrap" }
const _hoisted_6 = {
  class: "sign",
  style: {"margin-bottom":"30px"}
}
const _hoisted_7 = { class: "sign" }
const _hoisted_8 = { class: "sign" }
const _hoisted_9 = { class: "image-wrap" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信公众号", -1))

import { ref, reactive, toRefs } from "vue";
import { ElOption, ElSelect } from "element-plus";
import "element-plus/theme-chalk/el-option.css";
import "element-plus/theme-chalk/el-select.css";
import "element-plus/theme-chalk/base.css";
import { getSettingList, getLinkList } from "../../request/api";
// 获取官网设置

export default /*#__PURE__*/_defineComponent({
  __name: 'footerCom',
  setup(__props) {

const baseConfig = ref({});
let getConfig = () => {
  getSettingList({}).then(res => {
    baseConfig.value = res.data.data;
    console.log(baseConfig.value, "baseConfig1111");
  });
};
getConfig();
// 获取友情链接兄弟部门
let departmentLink = ref({});
let getDepartment = () => {
  getLinkList({}).then(res => {
    departmentLink.value = res.data.code == 200 ? res.data.data : {};
    console.log(departmentLink.value, "m232323");
  });
};
getDepartment();

let toPartment = (url: String) => {
  let url1 = url.substr(0, 4) == "http" ? url : "http://" + url;
  window.open(url1);

  // window.open(url);
  // window.open("https://" + url);
  // window.open("http://47.108.236.111/client/");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(departmentLink), (item, index) => {
        return (_openBlock(), _createBlock(_unref(ElSelect), {
          key: index,
          class: "select",
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
          placement: "top-start",
          placeholder: item.name
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem, subIndex) => {
                return (_openBlock(), _createBlock(_unref(ElOption), {
                  key: subItem.id,
                  onClick: ($event: any) => (_unref(toPartment)(subItem.url)),
                  label: subItem.name,
                  value: subItem.id
                }, null, 8, ["onClick", "label", "value"]))
              }), 128))
            ])
          ]),
          _: 2
        }, 1032, ["modelValue", "placeholder"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, " 主办单位：" + _toDisplayString(baseConfig.value.company_name), 1),
        _createElementVNode("div", _hoisted_7, " 地址：" + _toDisplayString(baseConfig.value.company_address) + "  /  联系电话：" + _toDisplayString(baseConfig.value.phone), 1),
        _createElementVNode("div", _hoisted_8, " 版权所有：" + _toDisplayString(baseConfig.value.copyright) + "  / 备案号：" + _toDisplayString(baseConfig.value.filing_code), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("img", {
          src: baseConfig.value.mq_url,
          alt: ""
        }, null, 8, _hoisted_10),
        _hoisted_11
      ])
    ])
  ]))
}
}

})